var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoldMedal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.619 13.4218L12.2255 14.3493L8.96311 20L8.02673 17.9116L10.619 13.4218Z",
    fill: "#CE4444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.619 13.4218L9.01241 12.4943L5.75 18.1449L8.02675 17.9117L10.619 13.4218Z",
    fill: "#983535"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.911 13.4218L11.3044 14.3493L14.5669 20L15.5032 17.9116L12.911 13.4218Z",
    fill: "#983535"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.911 13.4218L14.5176 12.4943L17.78 18.1449L15.5032 17.9117L12.911 13.4218Z",
    fill: "#CE4444"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2467 9.5311C17.2467 12.5858 14.7704 15.0621 11.7156 15.0621C8.66092 15.0621 6.18457 12.5858 6.18457 9.5311C6.18457 6.47635 8.66092 4 11.7156 4C14.7704 4 17.2467 6.47635 17.2467 9.5311Z",
    fill: "url(#paint0_linear_97_5220)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0332 9.53111C16.0332 11.9156 14.1002 13.8487 11.7157 13.8487C9.3312 13.8487 7.39819 11.9156 7.39819 9.53111C7.39819 7.14663 9.3312 5.21362 11.7157 5.21362C14.1002 5.21362 16.0332 7.14663 16.0332 9.53111Z",
    fill: "#A88300"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2739 9.99199C16.2739 12.382 14.3364 14.3195 11.9463 14.3195C9.55629 14.3195 7.61877 12.382 7.61877 9.99199C7.61877 7.60194 9.55629 5.66443 11.9463 5.66443C14.3364 5.66443 16.2739 7.60194 16.2739 9.99199Z",
    fill: "#C28B37"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0434 9.53103C16.0434 11.9211 14.1059 13.8586 11.7159 13.8586C9.32582 13.8586 7.38831 11.9211 7.38831 9.53103C7.38831 7.14101 9.32582 5.20349 11.7159 5.20349C14.1059 5.20349 16.0434 7.14101 16.0434 9.53103Z",
    fill: "#C09525"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.739 6.52051L12.6725 8.38754L14.5396 8.62092L13.2575 10.0585L13.6061 12.1216L11.739 11.1881L9.87199 12.1216L10.2236 10.0585L8.93848 8.62092L10.8055 8.38754L11.739 6.52051Z",
    fill: "url(#paint1_linear_97_5220)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_97_5220",
    x1: 11.3401,
    y1: 6.01596,
    x2: 12.0906,
    y2: 19.9825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_97_5220",
    x1: 11.7391,
    y1: 6.52051,
    x2: 11.7391,
    y2: 12.1216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFCDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE896"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldMedal);
export default __webpack_public_path__ + "static/media/gold-medal.88b7158ac51f4397ec181569da05bc5c.svg";
export { ForwardRef as ReactComponent };